import React from "react";
import TopNavbar from "../../../shared/Layout/TopNavbar";
import { Button, IconButton } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DarkMode from "../../../shared/Layout/TopNavbar/DarkMode";
import FullscreenButton from "../../../shared/Layout/TopNavbar/FullscreenButton";
import Notifications from "../../../shared/Layout/TopNavbar/Notifications";
import Profile from "../../../shared/Layout/TopNavbar/Profile";
import ControlPanel from "../../../shared/Layout/ControlPanel";

import AddIcon from "@mui/icons-material/Add";

function TopNavigation({ toggleSidebar }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleAddClick = () => {
    navigate("/supervisor/add-new-user");
  };

  const showAddButton = ["/supervisor/operator", "/supervisor/operators"].some(
    (path) => location.pathname.startsWith(path)
  );
  console.log("Current Path:", location.pathname, showAddButton);
  return (
    <TopNavbar
      toggleActive={toggleSidebar}
      leftContent={
        <>
          {showAddButton && (
            <Button
              onClick={handleAddClick}
              startIcon={<AddIcon size="small" />}
              sx={{
                border: "none",
                boxShadow: "none",
                textTransform: "none",
                minWidth: "auto",
                padding: 0,
                color: "#3C5E23",
                "&:hover": {
                  backgroundColor: "transparent",
                  opacity: 0.8,
                },
              }}
            >
              Додати
            </Button>
          )}

          {/* <IconButton
            onClick={toggleSidebar}
            sx={{ display: { xs: "inline-flex", md: "none" } }}
          >
            <i className="material-symbols-outlined notranslate" translate="no">menu</i>
          </IconButton> */}
        </>
      }
      rightContent={
        <>
          <DarkMode />
          {/* <FullscreenButton /> */}
          <Notifications />
          <Profile />
          <ControlPanel />
        </>
      }
    />
  );
}

export default TopNavigation;
